import { render, staticRenderFns } from "./Type6c.vue?vue&type=template&id=a2796438&"
import script from "./Type6c.vue?vue&type=script&lang=js&"
export * from "./Type6c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports